import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { UNHMembershipPrincingTranslation } from '@frontend/unhideschool/app/utils/i18n/locale/unh-membership-pricing/unh-membership-pricing.i18n.model';
import { UseTranslations } from '@frontend/unhideschool/app/utils/i18n/use-translation.decorator';


interface Translations {
  "unh-membership-pricing": UNHMembershipPrincingTranslation;
}
interface BannerHighlightTranslation {
  title: string;
  message: string;
  imagePathMobile: string;
  imagePathDesktop: string;
  video: string;
}
@Component({
  selector: 'unh-banner-highlight',
  templateUrl: './banner-highlight.component.html',
  styleUrls: ['./banner-highlight.component.scss']
})
@UseTranslations({
  translatableComponents : ["unh-membership-pricing"]
})
export class BannerHighlightComponent implements OnInit {
  @Input() title: any;
  @Input() message: any;
  @Input() imagepathmobile: any;
  @Input() imagepathdesktop: any;
  @Input() video: any;


  bannerHighlightTranslation : BannerHighlightTranslation;
  membershipPricingMock : UNHMembershipPrincingTranslation;

  translations: Promise<Translations>;

  isMobile$: Observable<boolean>;

  constructor() { }

  ngOnInit(): void {
    this.translations.then((translations) => {
      this.membershipPricingMock = translations['unh-membership-pricing'];
    })
  }

}
